import asyncActionTypes from './types.js';
import errorTracking from '../../scripts/analytics/creators/manage';
import { getQuoteRefundData } from '../../api-wrapper/api.js';
import { sendAnalytics } from '../../scripts/analytics/tracker.js';

export const getQuoteRefundStart = () => ({
  type: asyncActionTypes.RETRIEVE_QUOTE_REFUND.START,
});

export const getQuoteRefund = (response) => ({
  type: asyncActionTypes.RETRIEVE_QUOTE_REFUND.SUCCESS,
  payload: response,
});

export const getQuoteRefundFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_QUOTE_REFUND.FAIL,
  error: error,
});

export default function getQuoteRefundDataActions(email, name, pnr) {
  return function action(dispatch) {
    dispatch(getQuoteRefundStart());
    const response = getQuoteRefundData(email, name, pnr);
    response.then(response => {
      if (response?.status >= 400 || response?.quoteError) {
        // eslint-disable-next-line no-console
        console.error(response);
        dispatch(getQuoteRefundFail());
        dispatch(
          sendAnalytics({
            eventCreator: errorTracking.errorTrackingRefund({
              event: 'error',
              type: 'FATAL',
              statusCode: response?.status,
              errorData: {
                code: '13116202',
                actionable: 'ABORT',
                msg: response?.Message || response?.message,
                extraInfo: {
                  // eslint-disable-next-line camelcase
                  debugging_stuff_here: response?.Message || response?.message,
                },
              },
              actionType: 'RETRIEVE_QUOTE_REFUND',
            }),
          })
        );
      } else {
        const quoteDescription = response?.quoteRefundResult?.description;
        const hasQuotations = response?.quotations?.length > 0;
        const isBusinessError = quoteDescription === 'QuoteProcessingError'
          || (quoteDescription === 'PolicyNotFulfilled' && !hasQuotations);

        if (isBusinessError) {
          dispatch(getQuoteRefundFail());
          dispatch(
            sendAnalytics({
              eventCreator: errorTracking.errorTrackingRefund({
                event: 'error',
                type: 'FATAL',
                statusCode: 200,
                errorData: {
                  code: '13116204',
                  actionable: 'ABORT',
                  msg: quoteDescription,
                  extraInfo: {
                    // eslint-disable-next-line camelcase
                    debugging_stuff_here: quoteDescription,
                  },
                },
                actionType: 'RETRIEVE_QUOTE_REFUND',
              }),
            })
          );
        } else {
          dispatch(getQuoteRefund(response));
        }
      }
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch(getQuoteRefundFail());
    });
  };
}